import { FormGroup } from '@angular/forms';

export function PasswordPolicy(controlName: string) : any{
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const charPattern = /[*@!#$%&()^]/;
        const numberPattern = /\d/;
        const alphabetPattern = /[A-Za-z]/;

        const passwordErrors = {
            passwordLength: false,
            passwordCharacter: false,
            passwordNumber: false,
            passwordCase: false
        };

        if (control.value.length < 8 || control.value.length > 15) {
            passwordErrors.passwordLength = true;
        } else {
            passwordErrors.passwordLength = false;
        }

        if (!charPattern.test(control.value)) {
            passwordErrors.passwordCharacter = true;
        } else {
            passwordErrors.passwordCharacter = false;
        }

        if (!numberPattern.test(control.value)) {
            passwordErrors.passwordNumber = true;
        } else {
            passwordErrors.passwordNumber = false;
        }

        if (!alphabetPattern.test(control.value)) {
            passwordErrors.passwordCase = true;
        } else {
            passwordErrors.passwordCase = false;
        }

        if (passwordErrors.passwordLength === true ||
            passwordErrors.passwordCharacter === true ||
            passwordErrors.passwordNumber === true ||
            passwordErrors.passwordCase === true) {
            control.setErrors(passwordErrors);
        } else {
            control.setErrors(null);
        }
    };
}
